/* ──────────────────────────────────────────────────────────────────
   Recently Viewed — tracker.

   Runs once on every page load (loaded globally from layout/theme.liquid).
   No-op unless the URL is a product page. On PDP, pushes the product
   handle onto a localStorage stack:
     • Most-recent first
     • Deduped (re-viewing moves it to the front, no duplicates)
     • Capped at 12 handles

   Read by snippets/recently-viewed.liquid (the band hydration script
   inside the empty cart state), which fetches sections/api-recently-
   viewed.liquid?handles=h1,h2,... to render cards.

   Designed to fail silently — privacy-mode browsers, full-storage,
   third-party-cookie blockers all just silently skip tracking. The
   empty-cart band hides itself when no handles are stored.
   ────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var KEY = 'hea_recently_viewed';
  var MAX = 12;

  try {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match) return;
    var handle = match[1];

    var list = [];
    try {
      var raw = localStorage.getItem(KEY);
      list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) list = [];
    } catch (e) { list = []; }

    // Dedupe + push to front
    list = list.filter(function (h) { return h && h !== handle; });
    list.unshift(handle);
    if (list.length > MAX) list.length = MAX;

    localStorage.setItem(KEY, JSON.stringify(list));
  } catch (e) {
    // Privacy mode, storage quota exceeded, etc. Silent.
  }
})();
